var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconThird = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  fill: "none",
  viewBox: "0 0 22 22"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.571 11c0 4.714-3.857 8.571-8.571 8.571S2.429 15.714 2.429 11s3.857-8.571 8.57-8.571c4.715 0 8.572 3.857 8.572 8.571m1.715 0c0 5.657-4.629 10.286-10.286 10.286S.714 16.657.714 11 5.343.714 11 .714 21.286 5.343 21.286 11"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 10.424a1 1 0 0 0 .498.865l4.554 2.64c.476.276 1.094.116 1.302-.395A6.8 6.8 0 0 0 17.857 11c0-3.433-2.557-6.298-5.86-6.784-.547-.08-.997.375-.997.927z"
}))));
export default SvgIconThird;